module.exports = __webpack_public_path__ + "5c114213/img/mini-logo.18817ee5.svg";